import { BaseResource } from 'utils/ApiUtils';


export default class Document extends BaseResource {
    constructor(args) {
        super(args, Document.attributes);
    };

    static columns = [
        { title: "ProjDocId", field: "ProjDocId", type: "string", hidden: true },
        { title: "File Name", field: "FriendlyFileName", type: "string" },
        { title: "File Type", field: "FileType", type: "string" },
        { title: "File Destination", field: "Description_DocFileDestination", type: "string", },
        { title: "DocFileDestinationId", field: "DocFileDestinationId_DocFileDestination", type: "string", hidden: true },
        { title: "FileName", field: "FileName", type: "string", hidden: true },
        { title: "Description", field: "Description" },
    ]
    static attributes = Document.columns.map(r => r.field);
    static expand = [{ 'DocFileDestination': { select: ['Description', 'DocFileDestinationId'] } }];
};